export const rankingItems = [
  { id: 1, title: '蜜桃精选：本周最受欢迎甜蜜短片合集', tag: '热播', views: '128.6万', rank: 1, category: '蜜桃视频', url: '#ranking' },
  { id: 2, title: '桃子剧场：夏日清新校园系列全集', tag: '新番', views: '96.3万', rank: 2, category: '桃子视频', url: '#ranking' },
  { id: 3, title: '苹果影院：高评分欧美大片限时放送', tag: '推荐', views: '87.1万', rank: 3, category: '苹果视频', url: '#ranking' },
  { id: 4, title: '榴莲独家：东南亚热门剧集抢先看', tag: '独家', views: '74.5万', rank: 4, category: '榴莲视频', url: '#ranking' },
  { id: 5, title: '芒果综艺：爆笑真人秀新一季开播', tag: '热播', views: '68.9万', rank: 5, category: '芒果视频', url: '#ranking' },
  { id: 6, title: '糖果动漫：治愈系日常番温暖上线', tag: '新番', views: '55.2万', rank: 6, category: '糖果视频', url: '#ranking' },
  { id: 7, title: '甜蜜纪录：自然风光超清纪录片系列', tag: '精选', views: '42.8万', rank: 7, category: '甜蜜视频', url: '#ranking' },
];

export const indexItems = [
  { id: 1, title: '蜜桃独家剧场', desc: '热门IP改编剧集，每周更新', count: '36部', icon: 'ri-movie-2-line', color: 'primary' },
  { id: 2, title: '桃子校园青春', desc: '清新甜蜜校园故事合集', count: '52部', icon: 'ri-heart-pulse-line', color: 'secondary' },
  { id: 3, title: '苹果高分影院', desc: '豆瓣8分以上精选影片', count: '128部', icon: 'ri-star-line', color: 'accent' },
  { id: 4, title: '榴莲海外剧场', desc: '东南亚及日韩热门剧集', count: '89部', icon: 'ri-global-line', color: 'primary' },
  { id: 5, title: '芒果综艺乐园', desc: '爆笑综艺与真人秀全天候', count: '64档', icon: 'ri-emotion-laugh-line', color: 'secondary' },
  { id: 6, title: '糖果动漫世界', desc: '日漫国漫经典与新品', count: '215部', icon: 'ri-rocket-line', color: 'accent' },
  { id: 7, title: '甜蜜纪录片库', desc: '自然人文超清纪录片', count: '73部', icon: 'ri-landscape-line', color: 'primary' },
  { id: 8, title: '短剧精选专区', desc: '精简短剧随时随地畅享', count: '156部', icon: 'ri-flashlight-line', color: 'secondary' },
  { id: 9, title: '超清4K专享', desc: '4K超清画质极致体验', count: '42部', icon: 'ri-4k-line', color: 'accent' },
];

export const aboutContent = {
  title: '关于糖心视频',
  paragraphs: [
    '糖心视频是一个汇聚蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频等甜蜜水果品牌的综合性高清在线观影平台。我们以"甜蜜共赏"为核心理念，致力于为广大用户提供超清画质、流畅播放的极致观影体验。',
    '平台覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日更新热门资源，确保用户第一时间看到最新最热的精彩内容。无论是国内热播剧集还是海外独家资源，糖心视频都能满足你的观影需求。',
    '自上线以来，糖心视频凭借稳定的超清画质和极速播放技术，已累计服务数千万用户。我们坚持免费高清的运营策略，让每一位影迷都能无负担地享受甜蜜的观影时光。',
  ],
  stats: [
    { label: '累计用户', value: '3800万+' },
    { label: '内容总量', value: '12万+部' },
    { label: '日更新量', value: '500+部' },
    { label: '合作品牌', value: '30+' },
  ],
};

export const mediaItems = [
  { id: 1, title: '蜜桃剧场《夏日烟火》第12集', category: '蜜桃视频·独家', duration: '45:22', quality: '超清4K', views: '89.3万', url: '#media', thumbnailSeq: 'media-card-01' },
  { id: 2, title: '桃子校园《青春不散场》大结局', category: '桃子视频·热播', duration: '52:10', quality: '超清', views: '136.7万', url: '#media', thumbnailSeq: 'media-card-02' },
  { id: 3, title: '苹果影院《星际迷航：新生》', category: '苹果视频·高分', duration: '2:18:45', quality: '4K杜比', views: '67.4万', url: '#media', thumbnailSeq: 'media-card-03' },
  { id: 4, title: '榴莲海外《曼谷假日》第8集', category: '榴莲视频·热播', duration: '48:35', quality: '超清', views: '54.2万', url: '#media', thumbnailSeq: 'media-card-04' },
  { id: 5, title: '芒果综艺《笑声工坊》第3季第5期', category: '芒果视频·热门', duration: '1:32:18', quality: '超清', views: '201.5万', url: '#media', thumbnailSeq: 'media-card-05' },
];

export const carouselItems = [
  {
    id: 1, title: '蜜桃独家：年度古装巨制《长安风月》震撼上线', desc: '顶级制作团队倾力打造，实力派演员联袂出演，再现盛唐风华。超清画质呈现每一帧绝美画面。', tag: '重磅上线', url: '#carousel', imageSeq: 'carousel-01',
  },
  {
    id: 2, title: '桃子视频夏日企划：百部校园青春片限时免费', desc: '即日起至八月底，桃子视频精选百部高评分校园青春影片全部免费观看，陪你度过甜蜜暑假。', tag: '限时活动', url: '#carousel', imageSeq: 'carousel-02',
  },
  {
    id: 3, title: '苹果影院奥斯卡专题：历年获奖影片全收录', desc: '从经典到最新，囊括近百部奥斯卡获奖及提名影片，苹果影院带你看遍世界电影巅峰之作。', tag: '专题策划', url: '#carousel', imageSeq: 'carousel-03',
  },
  {
    id: 4, title: '榴莲海外引进：东南亚年度票房冠军独家首播', desc: '榴莲视频独家买断多部东南亚票房冠军，中文精译字幕，超清画质呈现异域风情精彩故事。', tag: '独家首播', url: '#carousel', imageSeq: 'carousel-04',
  },
];

export const topicItems = [
  { id: 1, name: '#蜜桃剧场新剧开播', heat: '286.5万', url: '#topics' },
  { id: 2, name: '#夏日甜蜜观影指南', heat: '198.3万', url: '#topics' },
  { id: 3, name: '#桃子校园青春回忆', heat: '175.2万', url: '#topics' },
  { id: 4, name: '#苹果影院高分推荐', heat: '154.8万', url: '#topics' },
  { id: 5, name: '#榴莲海外独家首播', heat: '132.6万', url: '#topics' },
  { id: 6, name: '#芒果综艺爆笑合集', heat: '118.4万', url: '#topics' },
  { id: 7, name: '#糖果动漫新番速递', heat: '97.1万', url: '#topics' },
  { id: 8, name: '#超清4K观影体验', heat: '85.3万', url: '#topics' },
  { id: 9, name: '#甜蜜纪录片推荐', heat: '68.9万', url: '#topics' },
  { id: 10, name: '#极速播放不卡顿', heat: '56.7万', url: '#topics' },
];

export const commentItems = [
  { id: 1, name: '樱桃小丸子', avatar: '🍒', rating: 5, date: '2026-07-28', content: '糖心视频真的太棒了！超清画质看剧体验无敌，蜜桃视频的独家剧《长安风月》画面美到每一帧都能做壁纸。播放流畅不卡顿，终于不用忍受其他平台的渣画质了！', likes: 3286, url: '#comments' },
  { id: 2, name: '夏天要吃西瓜', avatar: '🍉', rating: 5, date: '2026-07-27', content: '朋友推荐的糖心视频，一开始被名字吸引，用了之后真香！桃子视频的校园剧合集超全，重温了好多青春回忆。最重要的是完全免费，画质还这么好，良心平台！', likes: 2154, url: '#comments' },
  { id: 3, name: '电影控阿星', avatar: '⭐', rating: 4, date: '2026-07-26', content: '作为资深影迷，苹果影院的高分片库真的让我惊喜。很多冷门佳片在这里都能找到超清版本，榴莲视频的海外剧场也超级给力，中文精译质量很高。希望后续能增加更多纪录片资源！', likes: 1876, url: '#comments' },
];

export const contactContent = {
  title: '联系我们',
  desc: '不论你是内容创作者、品牌合作方，还是热心的影迷观众，糖心视频都欢迎你的联系。如有内容投稿、商务合作或任何建议与反馈，请通过以下方式找到我们。',
  items: [
    { icon: 'ri-mail-line', label: '联系邮箱', value: 'contact@tangxin.video' },
    { icon: 'ri-wechat-line', label: '官方微信', value: '糖心视频TangXin' },
    { icon: 'ri-share-forward-line', label: '内容投稿', value: 'submit@tangxin.video' },
    { icon: 'ri-briefcase-line', label: '商务合作', value: 'biz@tangxin.video' },
  ],
};

export const cardItems = [
  {
    id: 1, title: '蜜桃视频《长安风月》幕后花絮独家揭秘', desc: '走进年度古装巨制的拍摄现场，看实力派演员如何演绎盛唐风华。服化道细节令人惊叹，每一帧都是壁纸级别的超清画面。', category: '独家幕后', date: '2026-07-29', url: '#cards', imageSeq: 'card-01',
  },
  {
    id: 2, title: '苹果影院：七月高评分影片TOP10盘点', desc: '本月苹果影院新增多部口碑炸裂的高分电影，从文艺片到商业大片应有尽有，超清画质还原大银幕震撼。', category: '月度盘点', date: '2026-07-28', url: '#cards', imageSeq: 'card-02',
  },
  {
    id: 3, title: '糖果动漫夏季新番导览：这五部不容错过', desc: '糖果动漫频道夏季档重磅来袭，多部人气续作与全新IP同步上线，治愈、热血、悬疑总有一款适合你。', category: '新番推荐', date: '2026-07-27', url: '#cards', imageSeq: 'card-03',
  },
  {
    id: 4, title: '芒果综艺《笑声工坊》第三季爆笑名场面回顾', desc: '第三季《笑声工坊》播出过半，整理了本季截至目前最令人捧腹的十大名场面，超清回放看过瘾。', category: '综艺精选', date: '2026-07-26', url: '#cards', imageSeq: 'card-04',
  },
  {
    id: 5, title: '榴莲视频东南亚剧集推荐：从泰剧到菲剧', desc: '榴莲视频持续引进东南亚优质剧集资源，从泰国浪漫爱情剧到菲律宾悬疑惊悚片，打开你的海外视野。', category: '海外推荐', date: '2026-07-25', url: '#cards', imageSeq: 'card-05',
  },
];

export const faqItems = [
  { id: 1, question: '糖心视频是否需要注册才能观看？', answer: '糖心视频大部分内容支持游客直接观看，无需注册登录。部分独家内容和超清4K画质可能需要简单注册，注册完全免费，仅需邮箱即可完成。' },
  { id: 2, question: '糖心视频支持哪些设备观看？', answer: '糖心视频全面支持电脑端（Windows/Mac）、移动端（iOS/Android）、平板及智能电视投屏。通过浏览器访问即可，无需安装任何插件，超清画质在所有设备上都能流畅播放。' },
  { id: 3, question: '视频播放卡顿怎么办？', answer: '糖心视频采用智能CDN加速和自适应码率技术，正常情况下超清画质也能极速流畅播放。如遇卡顿，建议检查网络连接，或手动切换至"流畅"画质模式，缓冲完成后即可恢复超清。' },
  { id: 4, question: '平台内容多久更新一次？', answer: '糖心视频每日更新超过500部内容，涵盖蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频等全品牌频道。热播剧集同步更新，综艺节目当天上线，确保你不会错过任何精彩。' },
  { id: 5, question: '如何向糖心视频投稿内容？', answer: '欢迎优质内容创作者入驻！请将作品样片及简介发送至投稿邮箱 submit@tangxin.video，我们的内容团队会在3个工作日内完成审核并回复。通过审核的作品将获得专属推荐位和流量扶持。' },
  { id: 6, question: '糖心视频的画质支持哪些规格？', answer: '平台支持流畅、高清、超清、4K等多种画质规格，用户可根据网络环境和设备性能自由切换。旗舰级设备推荐使用4K画质，普通设备超清模式即可获得极佳观影体验。' },
];

export const featureItems = [
  { id: 1, title: '超清画质', desc: '全站支持超清至4K分辨率，智能码率自适应，不同网络环境下都能获得最佳观影画质。', icon: 'ri-4k-line' },
  { id: 2, title: '极速播放', desc: '全球CDN加速节点覆盖，智能缓冲预加载技术，点击即播，拖动即看，告别等待。', icon: 'ri-speed-up-line' },
  { id: 3, title: '海量内容', desc: '汇聚蜜桃、桃子、苹果、榴莲、芒果等品牌，12万+部影片覆盖电影、剧集、综艺、动漫全品类。', icon: 'ri-stack-line' },
  { id: 4, title: '多端同步', desc: '电脑、手机、平板、电视一键投屏，观影记录云端同步，随时随地继续精彩。', icon: 'ri-device-line' },
];

export const updateItems = [
  { id: 1, date: '2026-07-30', title: '4K超清专区全新上线', desc: '糖心视频4K超清专区正式上线，首批42部精选影片已完成4K重制。', url: '#updates' },
  { id: 2, date: '2026-07-28', title: '智能推荐算法升级', desc: '新版AI推荐引擎上线，根据观影偏好精准推荐你可能喜欢的甜蜜内容。', url: '#updates' },
  { id: 3, date: '2026-07-25', title: '榴莲视频东南亚专区扩容', desc: '新增菲律宾、越南热门剧集专区，中文精译字幕同步上线。', url: '#updates' },
  { id: 4, date: '2026-07-22', title: '投屏功能全面优化', desc: '支持DLNA和AirPlay双协议投屏，智能电视观影体验大幅提升。', url: '#updates' },
  { id: 5, date: '2026-07-18', title: '糖果动漫夏季新番季启动', desc: '12部夏季新番同步日本播出，独家中文配音版本同步上线。', url: '#updates' },
  { id: 6, date: '2026-07-15', title: '夜间模式正式发布', desc: '全新深色主题夜间模式上线，夜间观影更护眼，视觉效果更沉浸。', url: '#updates' },
  { id: 7, date: '2026-07-10', title: '播放器性能大幅提升', desc: '播放器内核升级至最新版，内存占用降低40%，启动速度提升60%。', url: '#updates' },
  { id: 8, date: '2026-07-05', title: '用户积分体系上线', desc: '观影、签到、分享均可获取糖心积分，兑换独家内容和会员权益。', url: '#updates' },
];

export const appContent = {
  title: '随时随地 · 甜蜜共赏',
  desc: '糖心视频移动端全面适配，无需下载APP，浏览器打开即可享受超清观影体验。支持添加到手机桌面，一键直达甜蜜世界。',
  features: ['移动浏览器完美适配', '支持添加到主屏幕', '流量节省模式可选', '4G/5G/WiFi智能切换', '横竖屏自动适配'],
};

export const siteInfo = {
  name: '糖心视频',
  slogan: '蜜桃视频·桃子视频·苹果视频·榴莲视频·芒果视频 · 甜蜜水果共赏',
  footerDesc: '糖心视频汇聚蜜桃视频、桃子视频等甜蜜水果品牌，提供超清画质、流畅播放的在线观影体验。苹果、榴莲、芒果视频高清免费看，每日更新海量精彩内容。',
};

export const footerLinks = {
  content: [
    { label: '蜜桃视频', url: '#index' },
    { label: '桃子视频', url: '#index' },
    { label: '苹果视频', url: '#index' },
    { label: '榴莲视频', url: '#index' },
    { label: '芒果视频', url: '#index' },
    { label: '糖果动漫', url: '#index' },
  ],
  service: [
    { label: '平台特色', url: '#features' },
    { label: '常见问题', url: '#faq' },
    { label: '最新动态', url: '#updates' },
    { label: '移动端体验', url: '#app' },
    { label: '联系我们', url: '#contact' },
  ],
  partners: [] as { label: string; url: string }[],
};